const attrs = {
  name: "",
  description: "",
  has_second_list_value: false,
  input_type: "text",
  is_required: false,
  min_length: null,
  max_length: null,
  prefix: "",
  suffix: "",
  transform_to: null,
  list_values: [{ name: "", value: "" }],
  date_type: "day",
  date_format: "DD-MM-YYYY",
};

const options = {
  parentType: "spaces",
  parentKey: "space_id",
};

const getters = {
  campaignFields: (state, getters, rootState, rootGetters) => {
    const urlMapFields = rootGetters["queryMaps/urlMapFieldIds"];
    if (!urlMapFields) return;

    let fields = [];
    urlMapFields.forEach((fieldId) => {
      let field = state.content.find((x) => fieldId === x.id);
      if (!fields.includes(field)) {
        fields.push(field);
      }
    });
    return fields;
  },
};

export default {
  generic: {
    attrs,
    options,
  },
  getters,
};
